
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3 } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import CountryFilter from '@/components/football/filters/CountryFilter';
import LeagueFilter from '@/components/football/filters/LeagueFilter';

interface ResultsCardProps {
  resultsCountry: string | null;
  resultsLeague: string | null;
  orderedCountries: string[];
  resultsAvailableLeagues: string[];
  setResultsCountry: (country: string | null) => void;
  handleResultsLeagueSelect: (league: string) => string;
  handleTabChange: (value: string) => void;
  handleLatestClick: () => void;
}

export const ResultsCard: React.FC<ResultsCardProps> = ({
  resultsCountry,
  resultsLeague,
  orderedCountries,
  resultsAvailableLeagues,
  setResultsCountry,
  handleResultsLeagueSelect,
  handleTabChange,
  handleLatestClick,
}) => {
  return (
    <Card className="hover:shadow-lg transition-shadow w-full h-full">
      <CardHeader className="text-center">
        <BarChart3 className="w-24 h-24 mx-auto mb-4" />
        <CardTitle className="text-2xl">Results</CardTitle>
        <CardDescription className="text-lg">
          View latest match results or filter by league
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col">
        <Tabs defaultValue="latest" className="w-full" onValueChange={handleTabChange}>
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="latest" onClick={handleLatestClick}>Latest</TabsTrigger>
            <TabsTrigger value="custom">Custom</TabsTrigger>
          </TabsList>
          <TabsContent value="latest">
            <div className="mt-4">
              <Button 
                variant="outline" 
                className="w-full" 
                onClick={handleLatestClick}
              >
                View Latest Results
              </Button>
            </div>
          </TabsContent>
          <TabsContent value="custom" className="mt-4">
            <div className="space-y-3">
              <div className="space-y-2">
                <CountryFilter 
                  selectedCountry={resultsCountry} 
                  onCountrySelect={setResultsCountry} 
                  countries={orderedCountries} 
                />
                {resultsCountry && (
                  <LeagueFilter 
                    selectedLeague={resultsLeague} 
                    onLeagueSelect={handleResultsLeagueSelect} 
                    leagues={resultsAvailableLeagues} 
                  />
                )}
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default ResultsCard;
